import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

type BannersStatePayload = {
  bannerId: string;
  keyId: string | number;
};

type BannersState = {
  [key: BannersStatePayload['bannerId']]: BannersStatePayload['keyId'];
};

export const initialState: BannersState = {};

const bannersSlice = createSlice({
  name: 'banners',
  initialState,
  reducers: {
    addClosedBanner(state, action: PayloadAction<BannersStatePayload>) {
      state[action.payload.bannerId] = action.payload.keyId;
    },
  },
});

export function checkIfBannerIsClosed(payload: BannersStatePayload) {
  return createSelector(
    (state: RootState) => state.banners[payload.bannerId],
    bannerState => bannerState === payload.keyId,
  );
}

export const { addClosedBanner } = bannersSlice.actions;
export default bannersSlice.reducer;
